export default cns => {
  // Garante que é uma string e remove tudo que não for dígito
  cns = String(cns).replace(/\D/g, '')

  if (cns.length !== 15) return false

  let soma = 0
  for (let i = 0; i < 15; i++) {
    soma += parseInt(cns[i]) * (15 - i)
  }

  return soma % 11 === 0
}
